
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LIcon, LCircleMarker, LLayerGroup, LFeatureGroup, LControlLayers } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import { Component, Vue, Watch } from 'vue-property-decorator'
import "../styles/MarkerCluster.css";
import "../styles/MarkerCluster.Default.css";
import TheLoadingIndicator from '@/components/TheLoadingIndicator.vue'

import { commonModule, mapModule, filterModule, installationsModule, companyModule } from '@/store/modules/store-accessor'
import MapFilter from '../components/Filter/MapFilter.vue'
import { mapTileProviders } from "@/helpers/data";
import { openInstallationSideview } from "@/helpers/installationSideview";

@Component({
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LCircleMarker,
    LLayerGroup,
    LFeatureGroup,
    LPopup,
    LIcon,
    Vue2LeafletMarkerCluster,
    MapFilter,
    TheLoadingIndicator,
    LControlLayers,
  }
})

export default class Map extends Vue {
  canAddLayers = false;
  map: any;
  popup: any;
  features: any;
  staticAnchor = [16, 37]
  zoom = 7
  center = L.latLng(this.companyCoordinates[0], this.companyCoordinates[1]) || null
  url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  attribution =
    '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  withPopup = L.latLng(this.companyCoordinates[0], this.companyCoordinates[1])
  currentZoom = 8
  currentCenter = L.latLng(this.companyCoordinates[0], this.companyCoordinates[1])
  showParagraph = false
  mapOptions = {
    zoomSnap: 0.5,
    preferCanvas: true,
  }
  selectedMarker: any = null;
  selecterMarkerTrueLocation: any = null;
  markerList: any = [];
  markerCluster = L.markerClusterGroup({ chunkedLoading: true });

  mapCompanyLogo = L.divIcon({});
  mapCompanyLogoCoordinates = [0, 0];

  get markers() {
    if(mapModule.markers.length > 0) {
      this.canAddLayers = true;
    }
    else {
      this.canAddLayers = false;
    }
    return mapModule.markers
  }

  get markersLength() {
    return this.markers.length
  }

  get isLoading() {
    return mapModule.isLoading;
  }

  @Watch('selectedMarker')
  openMarkerPopup() {
    this.features.mapObject.openPopup(this.selecterMarkerTrueLocation);
  }

  mapReady() {
    this.map = this.$refs.installationMap as LMap
    this.popup = this.$refs.popup as LPopup
    this.features = this.$refs.features as LLayerGroup

    //This can be used to center based on Installation 0 when the feature is implemented
    this.map.mapObject.setView([this.companyCoordinates[0], this.companyCoordinates[1]], 15);

    this.mapCompanyLogo = L.divIcon({
      html: `
      <div style="width: 40px; height: 40px; border-radius: 50%; overflow: hidden; display: flex; align-items: center; justify-content: center; background-color: white; border: 2px solid #ccc;">
      <img src="${this.companyLogo}" style="width: 100%; height: 100%; object-fit: ${this.companyLogoObjectFitValue};" />
      </div>`,
      iconSize: [0, 0],
      iconAnchor: [20, 40],
    });
    this.mapCompanyLogoCoordinates = [this.companyCoordinates[0], this.companyCoordinates[1]];
  }

  @Watch('canAddLayers')
  addMarkers() {
    this.markerCluster.clearLayers();
    this.markerList = [];
    if (this.markersLength > 0) {
      for (let i = 0; i < this.markers.length; i++) {
        let markerTest = L.circleMarker(this.markers[i].coord, {
          radius: 10,
          fillOpacity: 0.6,
          fillColor: this.$vuetify.theme.currentTheme.success, //Change color based on last Service,
          opacity: 1,
          weight: 1,
          color: this.$vuetify.theme.currentTheme.success,
        });

        markerTest.popupData = this.markers[i];

        markerTest.on('click', (e: any) => {
          this.selecterMarkerTrueLocation = e.latLng;
          this.selectedMarker = this.markers[i];
        });

        markerTest.bindPopup(this.popup.mapObject);
        this.markerList.push(markerTest);
      }

      this.markerCluster.addLayers(this.markerList);
      this.map.mapObject.addLayer(this.markerCluster);
      mapModule.setIsLoading(false);

    }
  }

  async selectInstallation(id: string) {
    try {
      mapModule.setIsLoading(true);
      await openInstallationSideview({ installationId: id });
    } catch (error) {
      // Sideview open failed (e.g. installation deleted).
    } finally {
      mapModule.setIsLoading(false);
    }
  }

  async mounted () {
    this.canAddLayers = false;
    this.markerList = [];
    mapModule.setIsLoading(true);
    await mapModule.getMarkersAction('');
    await companyModule.getCompanyInfo();
    filterModule.getMapFilters();
    commonModule.initSnackbar({});
    this.mapReady();
  }

  destroyed() {
    mapModule.clearMarkers();
  }

  async refreshData() {
    mapModule.setIsLoading(true);
    await mapModule.getMarkersAction(mapModule.filters);
    await filterModule.getMapFilters();
    mapModule.setIsLoading(false);
  }

  mapTileProviders() {
    return mapTileProviders();
  }

  get companyCoordinates() {
    return [companyModule.company.latitude, companyModule.company.longitude];
  }

  get companyLogo() {
    return companyModule.company.company_logo_link ?
    companyModule.company.company_logo_link :
    require("@/assets/img/new_logo_map.png");
  }

  get companyLogoObjectFitValue() {
    return companyModule.company.company_logo_link ? 'cover' : 'contain';
  }

  get showCompanyMarker() {
    return companyModule.company.showCompanyMapMarker;
  }

}
